import React from 'react';
export function AuthorityStatementSection() {
  return <section className="pt-10 pb-4 md:pt-16 md:pb-6 px-6 bg-background" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <div className="bg-navy rounded-xl border border-amber/40 px-8 py-8 md:px-12 md:py-10" data-id="element-15">
          <p className="text-amber/90 text-xs md:text-sm font-bold tracking-[0.2em] uppercase mb-4" data-id="element-16">
            El respaldo detrás del método
          </p>
          <p className="text-white/85 text-base md:text-lg leading-relaxed font-light" data-id="element-17">
            Este protocolo es el resultado de más de{' '}
            <strong className="text-white font-medium" data-id="element-18">
              30 años de estudio en biomecánica aplicada
            </strong>{' '}
            y sistemas de energía interna. Diseñado para optimizar el motor
            biológico y recuperar el enfoque que la mayoría de los profesionales
            dio por perdido a los 40 años.
          </p>
        </div>
      </div>
    </section>;
}